var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 41,
    viewBox: "0 0 35 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63035 6.8544L3.30825 12.399L4.62208 15.1841L7.55057 15.0321L9.63035 6.8544Z",
    fill: "#6196FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3939 17.4881L9.63035 6.8544L7.55057 15.0321L12.3939 17.4881Z",
    fill: "#6196FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91801 23.0577L4.62208 15.1841L7.55057 15.0321L8.91801 23.0577Z",
    fill: "#6196FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3939 17.4881L8.91801 23.0577L7.55057 15.0321L12.3939 17.4881Z",
    fill: "#6196FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06221 16.6526L0.948505 20.6863L3.72133 23.8L5.40393 20.84L2.06221 16.6526Z",
    fill: "#6196FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14735 25.9702L5.40393 20.84L3.72133 23.8L7.63091 27.3074L9.14735 25.9702Z",
    fill: "#6196FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37538 28.4698L7.63091 27.3074L3.72133 23.8L2.89159 26.299L6.37538 28.4698Z",
    fill: "#6196FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.4137L0.948505 20.6863L3.72133 23.8L2.89159 26.299L0 24.4137Z",
    fill: "#6196FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4573 0.5V9.57658L11.5453 9.956L12.0111 5.52572L17.4573 0.5Z",
    fill: "#6196FE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4573 9.57658V15.5515L14.7203 17.071L11.5453 9.956L17.4573 9.57658Z",
    fill: "#6196FE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4571 18.4441V25.1178L11.5754 24.6933V21.5961L17.4571 18.4441Z",
    fill: "#6196FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4571 31.0555V25.1178L11.5754 24.6933V27.9035L17.4571 31.0555Z",
    fill: "#6196FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5751 27.8891V34.5622L5.69403 34.1377V31.0405L11.5751 27.8891Z",
    fill: "#6196FE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5751 40.5V34.5622L5.69403 34.1377V37.3486L11.5751 40.5Z",
    fill: "#6196FE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5751 27.8891V34.5622L17.4571 34.1377V31.0405L11.5751 27.8891Z",
    fill: "#6196FE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5751 40.5V34.5622L17.4571 34.1377V37.3486L11.5751 40.5Z",
    fill: "#6196FE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.242 6.8544L31.5635 12.399L30.2503 15.1841L27.3218 15.0321L25.242 6.8544Z",
    fill: "#6196FE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4777 17.4881L25.242 6.8544L27.3218 15.0321L22.4777 17.4881Z",
    fill: "#6196FE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9532 23.0577L30.2503 15.1841L27.3218 15.0321L25.9532 23.0577Z",
    fill: "#6196FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4777 17.4881L25.9532 23.0577L27.3218 15.0321L22.4777 17.4881Z",
    fill: "#6196FE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8105 16.6526L33.9242 20.6863L31.1513 23.8L29.4688 20.84L32.8105 16.6526Z",
    fill: "#6196FE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7238 25.9702L29.4688 20.84L31.1513 23.8L27.2402 27.3074L25.7238 25.9702Z",
    fill: "#6196FE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4966 28.4698L27.2402 27.3074L31.1513 23.8L31.9804 26.299L28.4966 28.4698Z",
    fill: "#6196FE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8718 24.4137L33.9242 20.6863L31.1513 23.8L31.9804 26.299L34.8718 24.4137Z",
    fill: "#6196FE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4146 0.5V9.57658L23.326 9.956L22.8608 5.52572L17.4146 0.5Z",
    fill: "#6196FE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4146 9.57658V15.5515L20.1516 17.071L23.326 9.956L17.4146 9.57658Z",
    fill: "#6196FE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4146 18.4441V25.1178L23.2957 24.6933V21.5961L17.4146 18.4441Z",
    fill: "#6196FE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4146 31.0555V25.1178L23.2957 24.6933V27.9035L17.4146 31.0555Z",
    fill: "#6196FE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.296 27.8891V34.5622L29.177 34.1377V31.0405L23.296 27.8891Z",
    fill: "#6196FE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.296 40.5V34.5622L29.177 34.1377V37.3486L23.296 40.5Z",
    fill: "#6196FE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.296 27.8891V34.5622L17.4146 34.1377V31.0405L23.296 27.8891Z",
    fill: "#6196FE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.296 40.5V34.5622L17.4146 34.1377V37.3486L23.296 40.5Z",
    fill: "#6196FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.3ce34ccf7c6d158297afc02358aa0761.svg";
export { ForwardRef as ReactComponent };